import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Link as RouterLink } from "react-router-dom";

import type { Schema } from "@bw/shared/types/generated";

type ReadinessItem = Schema["FacilityApprovalReadinessItem"];

export function FacilityReadinessIssues({
  issues,
  title,
}: {
  issues: ReadinessItem[];
  title: string;
}) {
  if (issues.length === 0) return null;

  return (
    <Box component="section">
      <Typography component="h3" variant="subtitle2" sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Stack
        component="ul"
        spacing={1.25}
        sx={{ listStyle: "none", m: 0, p: 0 }}
      >
        {issues.map((issue, issueIndex) => (
          <Box
            component="li"
            key={`${issue.code}:${issueIndex}`}
            sx={{ borderLeft: 2, borderColor: "divider", pl: 1.5 }}
          >
            <Typography variant="body2">{issue.message}</Typography>
            {(issue.related_facility_ids ?? []).length > 0 && (
              <Stack
                direction="row"
                spacing={1.5}
                useFlexGap
                sx={{ flexWrap: "wrap", mt: 0.75 }}
              >
                {(issue.related_facility_ids ?? []).map(
                  (relatedFacilityId, relatedIndex) => (
                    <Link
                      key={`${issueIndex}:${relatedIndex}`}
                      component={RouterLink}
                      to={`/facilities/${encodeURIComponent(relatedFacilityId)}`}
                      aria-label={`Open related facility from ${title.toLowerCase()} issue ${issueIndex + 1}, link ${relatedIndex + 1}`}
                      variant="body2"
                      underline="hover"
                    >
                      Open related facility
                    </Link>
                  ),
                )}
              </Stack>
            )}
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
